import React from 'react';
import Nav from './nav/Nav';
import Home from './home/Home';
import Services from './services/Services';
import Contact from './contact/Contact';
import About from './about/About';
import Footer from './footer/Fotter';
import SingleService from './services/SingleService';
import {  Route  } from 'react-router-dom';


class Main extends React.Component{

    render(){
        return (
            <div className="main">
                <Nav/>
                <Route  exact path="/" component={Home}/>
                <Route  exact path="/services" component={Services}/>
                <Route path="/services/:title" component={SingleService}/>
                <Route path="/contact" component={Contact}/>
                <Route path="/about" component={About}/>  
                <Footer/>                  
            </div>
        );
    }
}
export default Main;


// WEBPACK FOOTER //
// ./src/components/main.js